import {
  AGE,
  AGES,
  MARITAL_STATUS,
  PARTNER_NAME,
  TAX_FILING_STATE,
  INCOME,
  EXPENSES,
  CHILDREN,
  CHILDREN_DETAILS,
  DEBTS,
} from '../SummaryConstants';

const DICTIONARY = {
  [MARITAL_STATUS]: {
    iterator: [0, 0],
    title: 'Partner',
  },
  [PARTNER_NAME]: {
    iterator: [0, 1],
    title: 'Partner\'s Name',
  },
  [AGES]: {
    iterator: [0, 2],
    title: 'Ages',
  },
  [AGE]: {
    iterator: [0, 2],
    title: 'Age',
  },
  [CHILDREN]: {
    iterator: [0, 3],
    title: 'Children',
  },
  [CHILDREN_DETAILS]: {
    iterator: [0, 4],
    title: 'Children Details',
  },
  [TAX_FILING_STATE]: {
    iterator: [1, 0],
    title: 'Tax Filing State',
  },
  [INCOME]: {
    iterator: [2, 0],
    title: 'Income',
  },
  [EXPENSES]: {
    iterator: [3, 0],
    title: 'Expenses',
  },
  [DEBTS]: {
    iterator: [4, 0],
    title: 'Debts',
  },
};
export default DICTIONARY;
